import '../fonts/ProdigySans-Regular.woff2';
import '../fonts/ProdigySans-Medium.woff2';
import '../fonts/ProdigySans-SemiBold.woff2';
import '../fonts/ProdigySans-Bold.woff2';

import '../fonts/ProdigySans-Medium.woff2';
import '../fonts/ProdigySans-Bold.woff2';

import 'aos/dist/aos.css';
import '../sass/main.scss';

import AOS from 'aos';
import Rellax from 'rellax';

import './common/custom-select.js';
import './common/focus.js';
import './common/screen-width.js';
import './common/screen-height.js';
import './common/css-variables.js';

import './layouts/cookies-notice.js';
import './layouts/site-header.js';
import './layouts/site-menu-modal.js';
import './layouts/site-menu-bar.js';

import './common/on-screen.js';

import { initModals } from './common/modals.js';

const initScrollAnimations = () => {
    AOS.init({
        duration: 750
    });

    window.addEventListener('load', () => AOS.refresh(), { once: true });
};

(() => {
    initModals();
    initScrollAnimations();
})();


const shape = document.querySelector('.floating-shapes__bottom svg');
let rotation = 0;
let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
  const currentScrollY = window.scrollY;
  const delta = currentScrollY - lastScrollY;

  rotation += delta * 0.05; // 0.3 controls sensitivity

  shape.style.transform = `rotate(${rotation}deg)`;

  lastScrollY = currentScrollY;
}, { passive: true });

var rellax = new Rellax('.rellax'); 